import React, { Fragment } from 'react'
import { Flexgrid, FlexgridItem, TextInput } from '@wf-wfria/pioneer-core'
import {
	SBA,
	ONBOARD,
	DLO,
	COBO,
	EASYCONNECT,
	PLINFOLEASE,
	RICOH,
	FORDPRO,
} from '../businessSegmentBrandIds'
import { SystemMessage } from './SystemMessages'

export function getfailedAttemptsMessageId(mode, messageId) {
	if (
		mode !== SBA &&
		mode !== ONBOARD &&
		mode !== DLO &&
		mode !== COBO &&
		mode !== EASYCONNECT &&
		messageId.includes('CLDP1017')
	) {
		return `api-service-error.forgotUserId.CLDP1017.message`
	}
	if (messageId.includes('CLDP1029')) {
		if (mode === PLINFOLEASE || mode === FORDPRO) {
			return 'api-service-error.forgotUserId.pl.CLDP1029.message'
		} else if (mode === RICOH) {
			return 'api-service-error.forgotUserId.ricoh.CLDP1029.message'
		}
		return 'api-service-error.forgotUserId.wf.CLDP1029.message'
	}
	if (messageId.includes('CLDP1030')) {
		if (mode === PLINFOLEASE || mode === FORDPRO) {
			return 'api-service-error.forgotUserId.pl.CLDP1030.message'
		} else if (mode === RICOH) {
			return 'api-service-error.forgotUserId.ricoh.CLDP1030.message'
		}
		return 'api-service-error.forgotUserId.wf.CLDP1030.message'
	}
	return messageId
}
export function ForgotUserIdContentInput({
	forgotUserIdMessage,
	dob,
	emailForgotUser,
	emailForgotUserRef,
	dobForgotUserRef,
	formatMessage,
	onUpdateInput,
	onTextInputValidator,
	mode,
}) {
	function onChange({ id, value }) {
		onUpdateInput(id, value)
	}

	const { messageId, iconKind, show } = forgotUserIdMessage

	const failedAttemptsMessageId = getfailedAttemptsMessageId(mode, messageId)
	return (
		<Flexgrid rowGap={2} columnGap={2}>
			<FlexgridItem span={8}>
				<SystemMessage
					className="ForgotUserIdMessage"
					show={show}
					iconKind={iconKind}
					messageId={failedAttemptsMessageId}
				/>
			</FlexgridItem>
			<FlexgridItem span={8}>
				<TextInput
					aria-label={formatMessage({
						id: 'forgot-user-id-form.form-content.email.aria-label',
					})}
					className="api-xsmall-margin-bottom"
					label={formatMessage({
						id: 'forgot-user-id-form.form-content.email.label',
					})}
					id="emailForgotUser"
					name="emailForgotUser"
					type="text"
					value={emailForgotUser.value}
					onValueChange={onChange}
					required={true}
					ref={emailForgotUserRef}
					aria-required={true}
					customValidators={[
						(value) => onTextInputValidator('emailForgotUser', value),
					]}
					nativeValidationMessages={{
						valueMissing: formatMessage({
							id: 'required-field.empty.error.label',
						}),
					}}
					labelClassName="wf-row wf-row--desk-3 wf-row--tab-3 wf-row--mob-only-12"
					fieldClassName="wf-row wf-row--desk-2 wf-row--tab-4 wf-row--mob-only-12"
				/>
			</FlexgridItem>
		</Flexgrid>
	)
}
